import { useForm } from "react-hook-form";

export type OrgFormValues = {
  name: string;
  identification_code: string;
  org_type: "agency" | "monitoring_company";
  contact_person: string;
  phone: string;
  email: string;
};

const DEFAULTS: OrgFormValues = {
  name: "",
  identification_code: "",
  org_type: "monitoring_company",
  contact_person: "",
  phone: "",
  email: "",
};

export function useOrgForm() {
  return useForm<OrgFormValues>({ defaultValues: DEFAULTS });
}
